export const isInAppBrowser = () => {
  // On iOS window.mobileApp is set after page load, before that we can rely on window.webkit
  // "preShowScriptSuccess" specifically is a handler injected by our inappbrowser plugin
  const preShowScriptSuccess = !!(
    window &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.preShowScriptSuccess
  )

  return preShowScriptSuccess || !!window.mobileApp
}

export const closeInAppBrowser = () => {
  window.mobileApp?.close()
}
async function waitForNativeMessage(type) {
  return new Promise(resolve => {
    let isResolved = false
    function resolveMatchingMessage(event) {
      const message = event?.detail?.message
      if (message?.type === type && !isResolved) {
        isResolved = true
        window.removeEventListener("messageFromNative", resolveMatchingMessage)
        resolve(message)
      }
    }
    window.addEventListener("messageFromNative", resolveMatchingMessage)
  })
}

export const fetchAccessTokenFromNative = async () => {
  if (!window.mobileApp) await waitForNativeMessage("webviewLoaded")
  window.mobileApp?.postMessage({ detail: { message: "requestToken" } })
  return waitForNativeMessage("accessTokenUpdated")
}

export default {
  isInAppBrowser,
  closeInAppBrowser,
  fetchAccessTokenFromNative
}
